import axios from '@/utils/http';

export default (
  pay_asset_price,
  asset_amount,
  all_price,
  advertisement_id,
  lang = 'en',
) => {
  const langObj = {
    'zh-cn': 'zh-CN',
    en: 'en',
  };
  lang = langObj[lang] || 'en';
  return axios
    .post('/multisig_orders', {
      advertisement_id,
      asset_amount,
      pay_asset_price,
      all_price,
      lang,
    })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
